import type {LucideIcon, LucideProps} from 'lucide-react';
import {forwardRef} from 'react';

import {
  ArrowLeft as LucideArrowLeft,
  ArrowRight as LucideArrowRight,
  ChevronDown as LucideChevronDown,
  ChevronUp as LucideChevronUp,
  ExternalLink as LucideExternalLink,
  LogOut as LucideLogOut,
  SquareX as LucideSquareX,
  UploadCloud as LucideUploadCloud,
  UserRound as LucideUserRound,
} from 'lucide-react';

export type IconType = LucideIcon;
export type IconProps = LucideProps;

type IconFactory = (icon: LucideIcon, displayName: string) => IconType;

const createIcon: IconFactory = (Icon, displayName) => {
  const WrappedIcon = forwardRef<SVGSVGElement, LucideProps>((props, ref) => (
    <Icon ref={ref} strokeWidth={1.75} aria-hidden focusable={false} {...props} />
  ));

  WrappedIcon.displayName = displayName;
  return WrappedIcon;
};

export const FiLogOut = createIcon(LucideLogOut, 'FiLogOut');
export const FiUser = createIcon(LucideUserRound, 'FiUser');
export const FiXSquare = createIcon(LucideSquareX, 'FiXSquare');
export const FiArrowLeft = createIcon(LucideArrowLeft, 'FiArrowLeft');
export const FiArrowRight = createIcon(LucideArrowRight, 'FiArrowRight');
export const FiExternalLink = createIcon(LucideExternalLink, 'FiExternalLink');
export const FiUploadCloud = createIcon(LucideUploadCloud, 'FiUploadCloud');
export const RxTriangleDown = createIcon(LucideChevronDown, 'RxTriangleDown');
export const RxTriangleUp = createIcon(LucideChevronUp, 'RxTriangleUp');
